import Grid from "../components/Grid/Grid";
import StartingPageContent from "../components/StartingPage/StartingPageContent";
const Forma = () => {
  return (
    <StartingPageContent pageName="Forma">
      <Grid></Grid>
    </StartingPageContent>
  );
};

export default Forma;
